import { Dialog } from "@headlessui/react"
import { KTitleSpan, KSpan, KButton, KDropdown, KInput } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { lang } from "../../../../../constants/languages"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { AdminPermission, User } from "../../../../../types"
import { users } from "../../../../../apis"
import { mapListToCamelCase } from "../../../../../utility"
import { toast } from "react-toastify"
import {
  ACCOUNTING_ADMIN_PERMISSION_LIST,
  ADMIN_PERMISSIONS,
  DISTRO_ADMIN_PERMISSION_LIST,
  DISTRO_ASSISTANT_ADMIN_PERMISSION_LIST,
  errorFilledToastOptions,
  successFilledToastOptions
} from "../../../../../constants"

const AdminPermissionModal = ({ open, onClose, user }: { open: boolean; onClose: () => void; user: User }) => {
  const [adminPermissionList, setAdminPermissionList] = useState<AdminPermission[]>([])
  const [userAdminPermissionList, setUserAdminPermissionList] = useState<string[]>([])

  const definedGroups: KSelectOption[] = [
    { label: "Clear", value: 0, value2: "" },
    { label: "All Access", value: 1, value2: Object.values(ADMIN_PERMISSIONS).join(",") },
    { label: "Distro Admin", value: 2, value2: DISTRO_ADMIN_PERMISSION_LIST.join(",") },
    { label: "Distro Admin Assitant", value: 3, value2: DISTRO_ASSISTANT_ADMIN_PERMISSION_LIST.join(",") },
    { label: "Accounting Admin", value: 2, value2: ACCOUNTING_ADMIN_PERMISSION_LIST.join(",") }
  ]

  useEffect(() => {
    users(`/admin_permissions/`, "get").then((resp) => {
      if (resp) setAdminPermissionList(mapListToCamelCase(resp.data.results))
    })
  }, [])

  useEffect(() => {
    setUserAdminPermissionList(user.adminPermissions?.split(",") || [])
  }, [user])

  const onSave = () => {
    users(`/save_admin_permission/?user_id=${user.id}&admin_permissions=${userAdminPermissionList.join(",")}`, "put")
      .then((resp) => {
        if (resp.data.success) {
          onClose()
          toast.success(`Successfully updated admin permission. Refresh to see result`, successFilledToastOptions)
        } else {
          toast.error(`Error saving admin permission`, errorFilledToastOptions)
        }
      })
      .catch(() => toast.error(`Error saving admin permission`, errorFilledToastOptions))
  }

  const onChangePermission = (adminPermission: AdminPermission) => {
    if (userAdminPermissionList.includes(adminPermission.code)) {
      const permissionListToUpdate = userAdminPermissionList.filter((permission) => permission !== adminPermission.code)
      setUserAdminPermissionList([...permissionListToUpdate])
    } else {
      userAdminPermissionList.push(adminPermission.code)
      setUserAdminPermissionList([...userAdminPermissionList])
    }
  }

  const renderAdminPermissions = () => {
    const groupedAdminPermissionList = adminPermissionList.reduce((acc: any, permission) => {
      const group = permission.group
      if (!acc[group]) acc[group] = []
      acc[group].push(permission)
      return acc
    }, {})
    return (
      <div>
        {Object.entries(groupedAdminPermissionList).map(([group, adminPermissionList]: [string, AdminPermission[]]) => {
          return (
            <div
              key={`${group}_admin_permission`}
              className="flex"
              style={{ width: "100%", height: "100%", borderTop: "1px dashed grey" }}
            >
              <div style={{ width: "12%" }}>
                <KTitleSpan text={group} fontSize={16} />
              </div>
              {adminPermissionList.map((permission: AdminPermission) => {
                return (
                  <div style={{ width: "12%" }} key={`${permission.id}_permission_id`}>
                    <div className="flex flex-col items-center gap-2 pt-1">
                      <KSpan text={permission.name} fontSize={15} />
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={userAdminPermissionList.includes(permission.code)}
                        onChange={() => onChangePermission(permission)}
                        style={{ accentColor: "black" }}
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose()
      }}
    >
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div
          className="p-6 shadow-md rounded-[10px] bg-[#fff]"
          style={{ width: "92%", height: "90%", overflowY: "scroll" }}
        >
          <div className="flex justify-between">
            <KTitleSpan fontSize={20} text={`Admin Permissions (${user.firstName} ${user.lastName})`} />
            <KButton text="Save" onClick={() => onSave()} width="80px" background="black" textColor="white" />
          </div>
          <div className="flex mt-1 mb-3 gap-3 items-center">
            <KSpan text="Quick Set: " />
            {definedGroups.map((permissions) => {
              return (
                <div key={`permission_pe${permissions.value}`}>
                  <KButton
                    text={permissions.label}
                    background="transparent"
                    height="32px"
                    onClick={() => setUserAdminPermissionList(permissions.value2?.split(",") || [])}
                  />
                </div>
              )
            })}
          </div>
          {renderAdminPermissions()}
        </div>
      </div>
    </Dialog>
  )
}

export default AdminPermissionModal
